import DE_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS from './de'
import EN_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS from './en'
import FR_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS from './fr'
import HU_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS from './hu'
import { T_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS } from './TYPES'

import { T_GENERIC_LANGUAGE_MAP } from '~/src/Constants/LANGUAGE'

import objectPathFactory from '~/src/Lib/objectPathFactory'

const TRIAL_NUDGE_POPUP_PAGE_CONSTANTS: T_GENERIC_LANGUAGE_MAP<T_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS> =
  {
    hu: HU_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS,
    en: EN_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS,
    fr: FR_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS,
    de: DE_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS
  }

export default TRIAL_NUDGE_POPUP_PAGE_CONSTANTS

export const TRIAL_NUDGE_POPUP_PAGE_CONSTANTS_PATH =
  objectPathFactory<T_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS>()
